import { onMounted, onUnmounted } from 'vue'

import { createAsideWidthPolicy, type AsideWidthPolicy } from './create-aside-width-policy'

const policies = new Map<string, AsideWidthPolicy>()

export const getAsideWidthPolicy = (storageKey: string): AsideWidthPolicy => {
  const existing = policies.get(storageKey)
  if (existing) return existing

  const created = createAsideWidthPolicy(storageKey)
  policies.set(storageKey, created)
  return created
}

/** Shared width policy for left/right asides (25% default, 300–520, persist, cross-tab). */
export const useAsideWidth = (storageKey: string) => {
  const policy = getAsideWidthPolicy(storageKey)

  onMounted(() => {
    policy.syncWidthFromPolicy()
    policy.attachListeners()
  })
  onUnmounted(() => {
    policy.detachListeners()
  })

  return {
    widthPx: policy.widthPx,
    isManualWidth: policy.isManualWidth,
    asideWidthStyle: policy.asideWidthStyle,
    setManualWidth: policy.setManualWidth,
    previewWidth: policy.previewWidth,
    resetToDefault: policy.resetToDefault,
    minWidthPx: policy.minWidthPx,
    maxWidthPx: policy.maxWidthPx,
  }
}
